export const siteInfo = {
  name: '吃瓜黑料',
  tagline: '娱乐圈真相，一个都不放过',
  description: '「吃瓜黑料」是一站式娱乐八卦聚合平台，成立于2024年。我们致力于汇集娱乐圈最新黑料、明星丑闻、网红翻车事件，以最快速度、最真爆料，让每一位吃瓜群众都能第一时间吃到最劲爆的瓜。',
  longDescription: '在信息爆炸的时代，娱乐圈的真真假假让人眼花缭乱。吃瓜黑料团队由一群资深的娱乐记者和行业内部人士组成，我们深耕娱乐圈多年，拥有广泛的人脉资源和可靠的信息渠道。我们的使命是：拨开娱乐圈的重重迷雾，还原事实真相，让每一个关心娱乐圈的用户都能看到水面下的真实景象。每日更新、独家内幕、真实爆料，我们从不藏着掖着。',
  founded: '2024年',
  stats: {
    articles: 12800,
    dailyVisitors: 500000,
    exclusiveReveals: 360,
  },
  contact: {
    email: 'tips@itxkf.cn',
    wechat: 'chiguaheila666',
    weibo: '@吃瓜黑料官方',
  },
  faqs: [
    {
      question: '吃瓜黑料的消息来源可靠吗？',
      answer: '我们的爆料信息均来自经过验证的可靠渠道，包括圈内人士提供的一手信息、公开可查证的资料以及多方交叉验证的消息。对于未经证实的信息，我们会明确标注"传闻"或"待核实"。我们始终坚持真实性第一的原则。',
    },
    {
      question: '如何向吃瓜黑料提供爆料？',
      answer: '欢迎通过邮箱 tips@itxkf.cn 或微信公众号 chiguaheila666 向我们提供爆料。我们承诺对所有爆料人信息严格保密，绝不泄露信息源。对于有重大价值的独家爆料，我们还会提供相应的爆料奖励。',
    },
    {
      question: '吃瓜黑料会删除已发布的文章吗？',
      answer: '我们只会在以下情况删除文章：文章内容被证实存在重大事实性错误、相关当事人提供了确凿的澄清证据、或者法律明确要求。我们不会因为任何形式的"公关压力"而删除真实报道。',
    },
    {
      question: '网站上的文章多久更新一次？',
      answer: '我们保持每日更新的频率，团队全天候监控娱乐圈动态，确保重大爆料在第一时间发布。一般每天至少有3-5篇新文章上线，重大事件发生时会有更多实时跟进报道。',
    },
  ],
};